import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const QuizVariantSelectionScreen = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { quizMode, username } = location.state || {};

  if (!quizMode || !username) {
    navigate("/");
    return null;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [variant, setVariant] = useState("");

  const handleSelection = (selectedVariant) => {
    setVariant(selectedVariant);
    if (quizMode === "timed") {
      // For timed mode, navigate to a separate difficulty selection page.
      navigate("/timed-difficulty", { state: { username, variant: selectedVariant } });
    } else {
      // For normal mode, navigate directly to the normal quiz screen.
      if (selectedVariant === "personalized") {
        navigate("/normal-personalized", { state: { username } });
      } else {
        navigate("/normal-random", { state: { username } });
      }
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Select Quiz Variant</h2>
      <p style={styles.subtitle}>
        Quiz Mode: {quizMode.charAt(0).toUpperCase() + quizMode.slice(1)}
      </p>
      <button style={styles.button} onClick={() => handleSelection("personalized")}>
        Personalized Quiz
      </button>
      <button style={styles.button} onClick={() => handleSelection("random")}>
        Random Quiz
      </button>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#e6f0fa',
    padding: '20px',
  },
  title: {
    fontSize: '2.5rem',
    color: '#4682b4',
    marginBottom: '1rem'
  },
  subtitle: {
    fontSize: '1.5rem',
    color: '#4682b4',
    marginBottom: '1.5rem'
  },
  button: {
    padding: '0.75rem 1.5rem',
    fontSize: '1rem',
    margin: '0.5rem',
    borderRadius: '8px',
    backgroundColor: '#4682b4',
    color: 'white',
    border: 'none',
    cursor: 'pointer',
    width: '80%',
    maxWidth: '300px'
  }
};

export default QuizVariantSelectionScreen;
